import { combineReducers } from 'redux';
import { AccountReducer } from './Account';
import { AllPermissionsReducer } from './AllPermissions';
import { BrandReducers } from './Brand';
import { BrowseNodeReducers } from './BrowseNode';
import { ConfigsReducer } from './Config';
import { DownTimeReducer } from './DownTime';
import { RecyclersReducer } from './Recyclers/index';

import { ExecutionReducers } from './Execution';
import { PermissionsReducer } from './Permissions';
import { RegionReducers } from './Region';
import { ReportReducers } from './Reports';
import { RulesReducer } from './Rules';
import { ServiceProviderReducers } from './ServiceProvider';
import { TargetReducers } from './Target';
import { UserReducers } from './User';

const reducer = combineReducers({
  target: TargetReducers,
  browseNodes: BrowseNodeReducers,
  region: RegionReducers,
  account: AccountReducer,
  brand: BrandReducers,
  serviceProvider: ServiceProviderReducers,
  execution: ExecutionReducers,
  users: UserReducers,
  report: ReportReducers,
  permissions: PermissionsReducer,
  allPermissions: AllPermissionsReducer,
  rules: RulesReducer,
  recyclers: RecyclersReducer,
  configs: ConfigsReducer,
  downTime: DownTimeReducer,
});
export default reducer;
